var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{staticClass:"list-style-none findingList mb-3",attrs:{"tag":_vm.layoutTag,"wrap":""}},[_c('v-flex',{staticClass:"findingList__title text-uppercase",attrs:{"wrap":"","tag":"h3"}},[_vm._v(_vm._s(_vm.name)+" :")]),_c('v-flex',{staticClass:"findingList__content",attrs:{"tag":_vm.contentTag}},[_vm._t("content")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }